import React from 'react'
import { useSelector } from 'react-redux'

type Props = {}

const NavigateListDepartment = (props: Props) => {
    const departmentListDrilling = useSelector((state: any) => state?.department)
    return (
        <div>
            <div>
                <ul className='flex'>
                    
                </ul>
            </div>
        </div>
    )
}

export default NavigateListDepartment